/* Calcul des zones d'impression, commun à l'outil (printtex-perso.js) et à la planche de contrôle
   (templates/page.planche-zones.liquid) : contours du vêtement sur la photo, puis rectangle de la zone. */
window.PrinttexZone = (() => {
  const ratioOf = (el) => (el ? (el.naturalHeight || el.height) / (el.naturalWidth || el.width) : 1.2);
  const boxes = new WeakMap();
  function garmentBox(el, opts = {}) {
    if (!el) return { x: 0, y: 0, w: 1, h: 1 };
    if (boxes.has(el)) return boxes.get(el);
    const c = document.createElement('canvas');
    c.width = 200;
    c.height = Math.round(200 * ratioOf(el));
    const ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(el, 0, 0, c.width, c.height);
    const d = ctx.getImageData(0, 0, c.width, c.height).data;
    const bg = [d[0], d[1], d[2], d[3]];
    const W = c.width; const Hh = c.height;
    const ecartBg = (i) => Math.abs(d[i] - bg[0]) + Math.abs(d[i + 1] - bg[1]) + Math.abs(d[i + 2] - bg[2]);
    // Vêtement presque de la couleur du fond (t-shirt blanc sur fond blanc) : tolérance serrée, sinon la détection le « mange ».
    let centre = 0; let nc = 0;
    for (let y = Math.round(Hh * 0.4); y < Hh * 0.6; y += 2) for (let x = Math.round(W * 0.4); x < W * 0.6; x += 2) { centre += ecartBg((y * W + x) * 4); nc++; }
    const TOLB = centre / nc < 45 ? 9 : 36;
    // Fond = ce qui touche le bord de la photo et a la couleur du fond (remplissage depuis les bords) : le blanc du vêtement,
    // entouré de son ombre ou de ses coutures, n'est jamais pris pour du fond.
    const fondM = new Uint8Array(W * Hh);
    const proche = (p) => (bg[3] < 20 ? d[p * 4 + 3] < 40 : ecartBg(p * 4) < TOLB);
    const pile = [];
    for (let x = 0; x < W; x++) pile.push(x, (Hh - 1) * W + x);
    for (let y = 0; y < Hh; y++) pile.push(y * W, y * W + W - 1);
    while (pile.length) {
      const p = pile.pop();
      if (fondM[p] || !proche(p)) continue;
      fondM[p] = 1;
      const x = p % W;
      if (x > 0) pile.push(p - 1); if (x < W - 1) pile.push(p + 1); if (p >= W) pile.push(p - W); if (p < W * (Hh - 1)) pile.push(p + W);
    }
    let x0 = W; let y0 = Hh; let x1 = -1; let y1 = -1;
    for (let y = 0; y < Hh; y++) {
      for (let x = 0; x < W; x++) {
        if (!fondM[y * W + x]) { x0 = Math.min(x0, x); x1 = Math.max(x1, x); y0 = Math.min(y0, y); y1 = Math.max(y1, y); }
      }
    }
    const b = x1 < 0 ? { x: 0, y: 0, w: 1, h: 1 }
      : { x: x0 / c.width, y: y0 / c.height, w: (x1 - x0 + 1) / c.width, h: (y1 - y0 + 1) / c.height };
    // Buste : entre 55 % et 80 % de la hauteur, segment de vêtement qui contient le milieu de la photo
    // (les manches longues, séparées du buste, ne comptent pas). Axe = médiane des milieux, largeur = médiane.
    // Ligne entière (manches comprises) gardée en secours pour l'axe.
    const estFond = (x, y) => fondM[y * W + x] === 1;
    const milieux = []; const bustes = []; const largeurs = [];
    const xm = Math.round((x0 + x1) / 2);
    for (let y = Math.round(y0 + (y1 - y0) * 0.55); y <= Math.round(y0 + (y1 - y0) * 0.8); y++) {
      let l = -1; let r = -1;
      for (let x = 0; x < c.width; x++) if (!estFond(x, y)) { if (l < 0) l = x; r = x; }
      if (l >= 0) milieux.push((l + r) / 2);
      if (estFond(xm, y)) continue;
      let bl = xm; let br = xm;
      while (bl > 0 && !estFond(bl - 1, y)) bl--;
      while (br < c.width - 1 && !estFond(br + 1, y)) br++;
      bustes.push((bl + br) / 2); largeurs.push(br - bl + 1);
    }
    const med = (a) => a.sort((p, q) => p - q)[a.length >> 1];
    b.cx = milieux.length ? med(milieux) / c.width : b.x + b.w / 2;
    // Buste mesuré seulement s'il est nettement plus étroit que le vêtement entier
    // (sinon les manches touchent le buste : largeur estimée à 57 % du vêtement, proportion habituelle).
    const tw = largeurs.length ? med(largeurs) / c.width : 0;
    if (tw && (tw < b.w * 0.75 || opts.sans_manches)) { b.cx = med(bustes) / c.width; b.tw = tw; } else b.tw = b.w * 0.57;
    // Bas du produit sur l'axe (ourlet du buste : les manches longues descendent souvent plus bas).
    const xa = Math.round(b.cx * c.width); b.bas = b.y + b.h;
    for (let y = c.height - 1; y > y0; y--) if (!estFond(xa, y)) { b.bas = (y + 1) / c.height; break; }
    // Haut du vêtement sur l'axe (col, ou haut de la capuche) : repère vertical des zones réglées en cm (z.col).
    b.col = b.y; for (let y = y0; y < c.height; y++) if (!estFond(xa, y)) { b.col = y / c.height; break; }
    boxes.set(el, b);
    return b;
  }

  /* Zone « forme » (short, débardeur ; retour Karim 16/10/2026) : la zone suit le contour du vêtement sur la photo,
     moins une marge de sécurité, sans la ceinture (z.haut = part de la hauteur exclue en haut) ni, pour un débardeur
     (z.buste), le col, les bretelles et les emmanchures (lignes nettement plus étroites que le buste). Grille 200 px. */
  const formes = new WeakMap();
  function masque(el, z) {
    const cle = JSON.stringify([z.haut, z.bas, z.marge, z.buste, z.encolure, z.pans, z.gauche, z.droite]);
    let parEl = formes.get(el);
    if (!parEl) { parEl = {}; formes.set(el, parEl); }
    if (parEl[cle]) return parEl[cle];
    const W = 200; const H = Math.round(200 * ratioOf(el));
    const c = document.createElement('canvas'); c.width = W; c.height = H;
    const ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(el, 0, 0, W, H);
    const d = ctx.getImageData(0, 0, W, H).data;
    const bg = [d[0], d[1], d[2], d[3]];
    // Même détection que garmentBox (17/10/2026) : fond rempli depuis les bords, tolérance plus fine si le vêtement
    // a presque la couleur du fond (blanc sur blanc) ; un blanc à l'intérieur du vêtement n'est plus pris pour du fond.
    const ecartBg = (i) => Math.abs(d[i] - bg[0]) + Math.abs(d[i + 1] - bg[1]) + Math.abs(d[i + 2] - bg[2]);
    let centre = 0; let nc = 0;
    for (let y = Math.round(H * 0.4); y < H * 0.6; y += 2) for (let x = Math.round(W * 0.4); x < W * 0.6; x += 2) { centre += ecartBg((y * W + x) * 4); nc++; }
    const tolF = centre / nc < 45 ? 9 : 36;
    const proche = (p) => (bg[3] < 20 ? d[p * 4 + 3] < 40 : ecartBg(p * 4) < tolF);
    const fondM = new Uint8Array(W * H); const pileF = [];
    const pousserF = (p) => { if (!fondM[p] && proche(p)) { fondM[p] = 1; pileF.push(p); } };
    for (let x = 0; x < W; x++) { pousserF(x); pousserF((H - 1) * W + x); }
    for (let y = 0; y < H; y++) { pousserF(y * W); pousserF(y * W + W - 1); }
    while (pileF.length) { const p = pileF.pop(); const x = p % W; const y = (p - x) / W; if (x) pousserF(p - 1); if (x < W - 1) pousserF(p + 1); if (y) pousserF(p - W); if (y < H - 1) pousserF(p + W); }
    const fond = (i) => fondM[i / 4] === 1;
    let m = new Uint8Array(W * H);
    let x0 = W; let y0 = H; let x1 = -1; let y1 = -1;
    for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) if (!fond((y * W + x) * 4)) { m[y * W + x] = 1; x0 = Math.min(x0, x); x1 = Math.max(x1, x); y0 = Math.min(y0, y); y1 = Math.max(y1, y); }
    if (x1 < 0) return null;
    const gh = y1 - y0 + 1; const gw = x1 - x0 + 1;
    const effacerAuDessus = (yl) => { for (let y = 0; y < yl; y++) m.fill(0, y * W, y * W + W); };
    if (z.haut) effacerAuDessus(Math.round(y0 + z.haut * gh));
    // z.encolure = [demi-largeur, profondeur] (fractions du vêtement) : retire l'encolure (demi-ellipse sous le haut,
    // centrée sur l'axe) au lieu d'une coupe droite ; la zone remonte de part et d'autre du col (débardeur femme).
    // z.pans = [[x, y] haut, [x, y] bas] (fractions du produit) : coutures du panneau avant (casquettes), symétriques ;
    // on retire ce qui est à l'extérieur (côtés, filet de la trucker).
    if (z.pans) {
      const [[ax, ay], [bx, by]] = z.pans;
      for (let y = y0; y <= y1; y++) {
        const t = Math.min(1, Math.max(0, ((y - y0) / gh - ay) / (by - ay)));
        const e = Math.round((ax + (bx - ax) * t) * gw);
        for (let x = 0; x < W; x++) if (x < x0 + e || x > x1 - e) m[y * W + x] = 0;
      }
    }
    if (z.encolure) {
      const a = z.encolure[0] * gw; const p = z.encolure[1] * gh; const cx = (x0 + x1) / 2;
      for (let y = y0; y <= y0 + p; y++) {
        const t = (y - y0) / p; const hl = a * Math.sqrt(Math.max(0, 1 - t * t));
        for (let x = Math.max(0, Math.floor(cx - hl)); x <= Math.min(W - 1, Math.ceil(cx + hl)); x++) m[y * W + x] = 0;
      }
    }
    // z.bas : part de la hauteur au-delà de laquelle on s'arrête (ex. tablier : au-dessus de la poche).
    if (z.bas) for (let y = Math.round(y0 + z.bas * gh); y < H; y++) m.fill(0, y * W, y * W + W);
    // z.gauche / z.droite : part de la largeur exclue à gauche / à droite (photo de trois quarts : filet de la trucker).
    if (z.gauche || z.droite) {
      const xg = Math.round(x0 + (z.gauche || 0) * gw); const xd = Math.round(x1 - (z.droite || 0) * gw);
      for (let y = 0; y < H; y++) { m.fill(0, y * W, y * W + xg); m.fill(0, y * W + xd + 1, y * W + W); }
    }
    if (z.buste) {
      const larg = (y) => { let n = 0; for (let x = 0; x < W; x++) n += m[y * W + x]; return n; };
      const ref = [];
      for (let y = Math.round(y0 + gh * 0.55); y <= Math.round(y0 + gh * 0.8); y++) ref.push(larg(y));
      ref.sort((a, b) => a - b);
      const lb = ref[ref.length >> 1] || gw;
      let coupe = y0;
      for (let y = y0; y < y0 + gh * 0.55; y++) if (larg(y) < lb * 0.92) coupe = y + 1;
      effacerAuDessus(coupe);
    }
    // Marge de sécurité : érosion carrée (lignes puis colonnes, sommes cumulées).
    const r = Math.max(1, Math.round((z.marge ?? 0.05) * gw));
    const eroder = (src, horiz) => {
      const out = new Uint8Array(W * H);
      const n = horiz ? W : H; const lignes = horiz ? H : W;
      const cum = new Int32Array(n + 1);
      for (let l = 0; l < lignes; l++) {
        for (let k = 0; k < n; k++) cum[k + 1] = cum[k] + (src[horiz ? l * W + k : k * W + l] ? 0 : 1);
        for (let k = 0; k < n; k++) {
          const a = Math.max(0, k - r); const b = Math.min(n, k + r + 1);
          if (src[horiz ? l * W + k : k * W + l] && cum[b] - cum[a] === 0) out[horiz ? l * W + k : k * W + l] = 1;
        }
      }
      return out;
    };
    m = eroder(eroder(m, true), false);
    let X0 = W; let Y0 = H; let X1 = -1; let Y1 = -1; let sx = 0; let sy = 0; let n = 0;
    for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) if (m[y * W + x]) { X0 = Math.min(X0, x); X1 = Math.max(X1, x); Y0 = Math.min(Y0, y); Y1 = Math.max(Y1, y); sx += x; sy += y; n++; }
    if (X1 < 0) return null;
    const res = { W, H, m, bx: X0 / W, by: Y0 / H, bw: (X1 - X0 + 1) / W, bh: (Y1 - Y0 + 1) / H, cx: sx / n / W, cy: sy / n / H };
    parEl[cle] = res;
    return res;
  }
  // Point (fractions de la photo) dans la forme ?
  const dansMasque = (f, fx, fy) => {
    const x = Math.floor(fx * f.W); const y = Math.floor(fy * f.H);
    return x >= 0 && y >= 0 && x < f.W && y < f.H && f.m[y * f.W + x] === 1;
  };
  // Contour de la forme en pointillés, dessiné dans ctx sur le rectangle (left, top, width, height) de la zone.
  function dessinerForme(ctx, f, r, mirror, couleur = '#ff6a00', halo = 'rgba(20, 18, 16, 0.8)') {
    const X0 = Math.round(f.bx * f.W); const Y0 = Math.round(f.by * f.H);
    const nx = Math.round(f.bw * f.W); const ny = Math.round(f.bh * f.H);
    const kx = r.width / nx; const ky = r.height / ny;
    ctx.fillStyle = couleur;
    for (let y = Y0; y < Y0 + ny; y++) {
      for (let x = X0; x < X0 + nx; x++) {
        const i = y * f.W + x;
        if (!f.m[i]) continue;
        const bord = !f.m[i - 1] || !f.m[i + 1] || !f.m[i - f.W] || !f.m[i + f.W];
        if (!bord || (x + y) % 3 === 0) continue; // pointillés
        const dx = mirror ? X0 + nx - 1 - x : x - X0;
        const px = r.left + dx * kx; const py = r.top + (y - Y0) * ky; const sx = Math.max(1.5, kx); const sy = Math.max(1.5, ky);
        if (halo) { ctx.fillStyle = halo; ctx.fillRect(px - 1, py - 1, sx + 2, sy + 2); ctx.fillStyle = couleur; } // lisible sur un vêtement clair
        ctx.fillRect(px, py, sx, sy);
      }
    }
  }

  function zoneRect(data, side, src, w, h, miroir) {
    const z = data.zones[side];
    if (z.forme) {
      const f = masque(src.el, z);
      if (f) {
        const bx = src.mirror ? 1 - f.bx - f.bw : f.bx;
        return { left: bx * w, top: f.by * h, width: f.bw * w, height: f.bh * h, forme: f, mirror: !!src.mirror };
      }
    }
    const b = { ...garmentBox(src.el, data) };
    if (src.mirror) { b.x = 1 - b.x - b.w; b.cx = 1 - b.cx; }
    // Zone centrée (x + w/2 = 0,5) : alignée sur l'axe du buste ; sinon (logo cœur…) position relative au vêtement.
    const centree = Math.abs(z.x + z.w / 2 - 0.5) < 0.02;
    // Vêtement à buste (torse_cm) : zone à l'échelle réelle (choix Karim 15/10/2026 : 35 × 40 cm max.) — pixels par cm
    // = buste mesuré sur la photo / largeur réelle du buste ; haut à z.col cm sous le haut du vêtement sur l'axe.
    // Sans torse_cm (sacs, bobs, casquettes…) : fraction de la largeur du produit, comme avant.
    const pxCm = data.torse_cm && z.col != null ? (b.tw * w) / data.torse_cm : 0;
    // Taille à l'écran (retour Karim 15/10/2026 : zones grandes, comme sur les autres sites) : la plus grande zone du
    // produit fait 80 % du buste, les autres à la même échelle ; la position (col, dx) reste en cm réels.
    const cmMax = Math.max(...Object.values(data.zones).map((x) => x.cmW));
    const pxAffiche = pxCm ? (0.8 * b.tw * w) / cmMax : 0;
    // z.larg : largeur à l'écran en fraction du buste (réglage par produit, retours Karim 16/10/2026).
    let width = pxCm ? (z.larg != null ? z.larg * b.tw * w : z.cmW * pxAffiche) : z.w * b.w * w;
    const top = pxCm ? b.col * h + z.col * pxCm : (b.y + z.y * b.h) * h;
    // La zone ne dépasse jamais du produit : bas au-dessus de l'ourlet mesuré sur l'axe (marge 4 %), sinon on la réduit.
    // Bas de zone : au moins 8 cm réels au-dessus de l'ourlet (vêtements à buste), sinon 4 % de la hauteur du produit.
    // z.ourlet : distance mini au bas du vêtement, en cm réels (8 par défaut).
    // z.bas_vetement : bas réel du vêtement (jogging : au milieu de la photo il y a l'entrejambe, pas l'ourlet).
    let basMax = (z.bas_vetement ? b.y + b.h : Math.min(b.y + b.h, b.bas ?? 1)) * h - (pxCm ? (z.ourlet ?? 8) * pxCm : b.h * 0.04 * h);
    if (z.fin != null) basMax = Math.min(basMax, (b.y + z.fin * b.h) * h); // ex. hoodie : au-dessus de la poche
    /* Zone esthétique (Karim 15/10/2026 : « un rendu comme dans la vraie vie ») : vêtement à buste, zone centrée →
       largeur de l'outil en ligne, du haut réglé (col) jusqu'à 8 cm de l'ourlet. Sa largeur vaut cmW imprimés ;
       la hauteur imprimée reste plafonnée à cmH par l'outil (le design ne peut pas dépasser 35 × 40 cm). */
    const allongee = pxCm && centree;
    // z.zone_cmH : hauteur de la zone dessinée (jogging : 75 cm de jambe) ; le visuel reste limité à cmH (40 cm).
    let height = allongee ? Math.max(20, basMax - top) : width * (z.zone_cmH ?? z.cmH) / z.cmW;
    if (!allongee && top + height > basMax) { width = Math.max(10, (basMax - top) * z.cmW / (z.zone_cmH ?? z.cmH)); height = width * (z.zone_cmH ?? z.cmH) / z.cmW; }
    let left = centree ? b.cx * w - width / 2 : pxCm && z.dx != null ? b.cx * w + z.dx * pxCm - width / 2 : (b.x + z.x * b.w) * w;
    // Petite zone côté cœur (zips, polos) placée en contre-cœur : symétrique par rapport à l'axe du buste.
    if (!centree && miroir) left = 2 * b.cx * w - left - width;
    return { left, top, width, height };
  }

  return { garmentBox, zoneRect, ratioOf, dansMasque, dessinerForme, setBox: (el, b) => boxes.set(el, b) };
})();
